/* global axios */
import ApiClient from './ApiClient';

class AppointmentServicesAPI extends ApiClient {
  constructor() {
    super('services', { accountScoped: true });
  }

  get(accountId, config) {
    return this.getForAccount(accountId, config);
  }

  create(data, accountId) {
    return axios.post(this.urlForAccount(accountId), data);
  }

  update(id, data, accountId) {
    return axios.patch(`${this.urlForAccount(accountId)}/${id}`, data);
  }

  delete(id, accountId) {
    return axios.delete(`${this.urlForAccount(accountId)}/${id}`);
  }
}

export default new AppointmentServicesAPI();
